require('./_set-species')('Array');


//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/babel-polyfill/~/core-js/modules/es6.array.species.js
// module id = 190
// module chunks = 0